import { render, staticRenderFns } from "./BarChartLegend.vue?vue&type=template&id=2c5457b4&scoped=true"
import script from "./BarChartLegend.vue?vue&type=script&lang=js"
export * from "./BarChartLegend.vue?vue&type=script&lang=js"
import style0 from "./BarChartLegend.vue?vue&type=style&index=0&id=2c5457b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5457b4",
  null
  
)

export default component.exports